export default "__VITE_ASSET__CON_E1a4__"